import { render, staticRenderFns } from "./VerifyFormMore.vue?vue&type=template&id=40cc7e62&scoped=true&"
import script from "./VerifyFormMore.vue?vue&type=script&lang=js&"
export * from "./VerifyFormMore.vue?vue&type=script&lang=js&"
import style0 from "./VerifyFormMore.vue?vue&type=style&index=0&id=40cc7e62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc7e62",
  null
  
)

export default component.exports